import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { setUpTOTP } from "aws-amplify/auth";

import { LoadingGroup, Spinner } from "capitalrx-components-2.0/lib/general";
import { Grid, Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import { ThemedAnchor, ThemedButton } from "../themed";

export interface SetupTOTPFormProps {
  readonly onSubmit: () => void | Promise<void>;
}

const QR_CODE_SIZE = 128;

export const SetupTOTPForm: FC<SetupTOTPFormProps> = ({ onSubmit }) => {
  const { t: translate } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [setupURI, setSetupURI] = useState("");

  const totpSetup = async () => {
    const totpSetupDetails = await setUpTOTP();
    setSetupURI(totpSetupDetails.getSetupUri("Capital Rx Member App").toString());
    setIsLoading(false);
  };

  useEffect(() => {
    totpSetup();
  }, []);

  return (
    <LoadingGroup loading={isLoading}>
      <LoadingGroup.Placeholder fallback={<Spinner size="large" />}>
        {setupURI && (
          <Stack>
            <Shelf>
              <Shelf.Spacer />
              <div style={{ width: QR_CODE_SIZE, height: QR_CODE_SIZE }}>
                <QRCode size={QR_CODE_SIZE} value={setupURI} viewBox={`0 0 ${QR_CODE_SIZE} ${QR_CODE_SIZE}`} style={{ height: "auto", maxWidth: "100%", width: "100%" }} />
              </div>
              <Shelf.Spacer />
            </Shelf>

            <Stack spacing="none">
              <Body textAlign="center">
                {translate("MULTIFACTOR_AUTHENTICATION.setupTotpForm.cannotScanQrCode")}
              </Body>
              <Body textAlign="center">
                <ThemedAnchor href={setupURI}>{translate("MULTIFACTOR_AUTHENTICATION.setupTotpForm.authenticatorAppSetup")}</ThemedAnchor>
              </Body>
            </Stack>

            <Grid>
              <ThemedButton onClick={onSubmit}>{translate("MULTIFACTOR_AUTHENTICATION.setupTotpForm.next")}</ThemedButton>
            </Grid>
          </Stack>
        )}
      </LoadingGroup.Placeholder>
    </LoadingGroup>
  );
};
